import Decimal from 'decimal.js-light';
import type { Struct, Validator } from 'superstruct';
import { coerce, define, string } from 'superstruct';

import { cleanRawDecimalValue } from '@adflow/shared/util-formatting';
/**
 * Decimal type validation, data is actually a string
 *
 * @param validator Optional validation function to test against the decimal. Return true if valid
 */
export const decimal: (
	validator?: (value: Decimal) => ReturnType<Validator>
) => Struct<string, null> = (validator) =>
	define('Decimal', (rawValue) => {
		try {
			const cleanedValue = cleanRawDecimalValue(rawValue);
			const value = new Decimal(cleanedValue);
			return validator?.(value) ?? true;
		} catch {
			return false;
		}
	});

export const positiveDecimal = () =>
	decimal((value) => {
		return value.greaterThanOrEqualTo(0)
			? true
			: { message: 'validations:Cannot be negative' };
	});

/**
 * Decimal type validation, but an empty string is coerced to 0
 */
export const decimalAllowEmpty = () =>
	coerce(decimal(), string(), (value) => (value === '' ? '0.00' : value));

/**
 * Positive decimal type validation, but an empty string is coerced to 0
 */
export const positiveDecimalAllowEmpty = () =>
	coerce(positiveDecimal(), string(), (value) =>
		value === '' ? '0.00' : value
	);
